import React from 'react';
import { TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { TabConfig } from '../tabsConfig';

interface TabTriggerProps {
  tab: TabConfig;
  activeCount: number | null;
  totalCount: number | null;
  canManageTramites: boolean;
}

const TabTrigger: React.FC<TabTriggerProps> = ({
  tab,
  activeCount,
  totalCount,
  canManageTramites
}) => {
  const Icon = tab.icon;

  return (
    <TabsTrigger
      value={tab.id}
      className="
        flex items-center justify-center whitespace-nowrap rounded-sm
        px-2 py-2 sm:px-3 sm:py-1.5 text-xs sm:text-sm font-medium
        ring-offset-background transition-all focus-visible:outline-none
        focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
        disabled:pointer-events-none disabled:opacity-50
        data-[state=active]:bg-primary data-[state=active]:text-primary-foreground
        data-[state=active]:shadow-sm gap-1 sm:gap-2 min-w-fit
        sm:flex-shrink-0 h-auto sm:h-8 overflow-hidden bg-transparent
      "
    >
      <Icon className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
      <span className="hidden sm:inline truncate">{tab.label}</span>
      <span className="sm:hidden text-center leading-tight truncate">{tab.label}</span>
      {!tab.Component && canManageTramites && activeCount !== null && totalCount !== null && (
        <Badge
          variant={activeCount > 0 ? "default" : "secondary"}
          className="text-xs px-1 sm:px-1.5 py-0 h-4 sm:h-5 min-w-[24px] sm:min-w-[28px] justify-center ml-0.5 sm:ml-1 flex-shrink-0"
        >
          {activeCount}/{totalCount}
        </Badge>
      )}
    </TabsTrigger>
  );
};

export default TabTrigger;